import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { createUserStorage } from './userStorage'

interface TaskInfo {
  assetType: string
  url: string
  isOpened: boolean
  openedAt: string | null
}

interface AssignedTaskInfoState {
  entries: Record<string, TaskInfo>
  setTaskInfo: (taskId: string, info: TaskInfo) => void
  getTaskInfo: (taskId: string) => TaskInfo | null
  clearTaskInfo: (taskId: string) => void
}

export const useAssignedTaskInfoStore = create<AssignedTaskInfoState>()(
  persist(
    (set, get) => ({
      entries: {},
      setTaskInfo: (taskId, info) =>
        set((state) => ({
          entries: { ...state.entries, [taskId]: info },
        })),
      getTaskInfo: (taskId) => get().entries[taskId] ?? null,
      clearTaskInfo: (taskId) =>
        set((state) => {
          const { [taskId]: _removedTaskInfo, ...rest } = state.entries

          return { entries: rest }
        }),
    }),
    {
      name: 'assigned-task-info',
      storage: createUserStorage(),
    },
  ),
)

export const rehydrateAssignedTaskInfoStore = () =>
  useAssignedTaskInfoStore.persist.rehydrate()

export const resetAssignedTaskInfoStore = () =>
  useAssignedTaskInfoStore.setState({ entries: {} })
